import React, { useEffect, useState } from "react";
import DefaultLayout from "../components/DefaultLayout";
import TabComponent from "../components/TabComponent";

const EInvoice = () => {
  return (
    <DefaultLayout showSearch={false}>
      <div className="einvoice-container">
        <div className="page-header" 
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom:'unset'
          }}>
          <h1>E-Invoice Submission</h1>
        </div>
        <TabComponent />
      </div>
    </DefaultLayout>
  );
};

export default EInvoice; 